import { CadService } from '@partful/features/instructions/cad/api/cadService';
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader';
import { ModelsService } from './modelsService';
import { ThreeService } from './threeService';

export class GltfService {
  constructor(
    private readonly cadService = new CadService(),
    private readonly modelsService = new ModelsService(),
    private readonly threeService = new ThreeService()
  ) {}

  async get(account: string, product: string): Promise<GLTF> {
    const url = await this.cadService.getPresignedUrl(account, product);
    const buffer = await this.modelsService.get(url);
    const model = await this.threeService.load(buffer);
    return model;
  }
}
